import { render, staticRenderFns } from "./v-chat-teaser.vue?vue&type=template&id=46c1962b&scoped=true&"
import script from "./v-chat-teaser.vue?vue&type=script&lang=js&"
export * from "./v-chat-teaser.vue?vue&type=script&lang=js&"
import style0 from "./v-chat-teaser.vue?vue&type=style&index=0&id=46c1962b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c1962b",
  null
  
)

export default component.exports